import { ColorEnum } from '@/constants/color'
import IconButton from '@/features/ui/buttons/components/IconButton'
import MenuItem from '@/features/ui/buttons/components/MenuButton/parts/MenuItem'
import Dropdown from '@/features/ui/components/Dropdown'
import MoreVertIcon from '@/features/ui/icons/components/MoreVertIcon'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

interface PaymentOptionsMenuProps {
    disabled: boolean
    onCalculator: () => void
}

const PaymentOptionsMenu: FC<PaymentOptionsMenuProps> = ({ disabled, onCalculator }) => {
    const { t } = useTranslation('app')
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (disabled) setOpen(false)
    }, [disabled])

    return (
        <Dropdown
            visible={open}
            preferredPosition="above"
            contentWidth="content"
            onClose={() => setOpen(false)}
            contentStyle={styles.menu}
            Anchor={
                <IconButton
                    Icon={MoreVertIcon}
                    color="secondary"
                    type="outline"
                    size={44}
                    disabled={disabled}
                    onPress={() => setOpen((current) => !current)}
                    accessibilityRole="button"
                    accessibilityLabel={t('openTabs.payment.options')}
                    testID="open-account-payment-options"
                    style={styles.button}
                />
            }
            ItemList={
                <MenuItem
                    label={t('openTabs.payment.calculator')}
                    disabled={disabled}
                    divider={false}
                    onPress={() => {
                        setOpen(false)
                        onCalculator()
                    }}
                />
            }
        />
    )
}

const styles = StyleSheet.create({
    button: { borderRadius: 8 },
    menu: {
        overflow: 'hidden',
        boxShadow: `0px 4px 4px 0px ${ColorEnum.GRAY_300}`,
    },
})

export default PaymentOptionsMenu
